module.exports = __webpack_public_path__ + "img/vac_upi_share_qr_code.74115c0d.png";